import ApiAttendance from "../gd/api/attendance";
import moment from "moment";
import AttendanceEvent from "../model2/attendance-event/attendance-event";
import ModalEditAttendance from "./clock-in-out/edit-clock-in-out";
import ModalAddAttendance from "./clock-in-out/add-attendance";
import ModalClockIn from "./clock-in-out/clock-in";
import ModalClockOut from "./clock-in-out/clock-out";
import AppMyAttendance from "../../views/attendance/app";
import FormModel from "../gd-form/common/form-model-manager";


export default class ModalClockInOut {

    clockIn = (app: AppMyAttendance)=>{
        gd.modal.showV4({
            className: '',
            component: ModalClockIn,
            params: {
                onSubmit: (values: any)=>{

                    const request = ApiAttendance.createClockIn({
                        userId    : gd.viewFor.userId,
                        date      : moment().format("YYYY-MM-DD"),
                        type      : 1,
                        comment   : values.comment,
                        deviceInfo: null,              /// Need to get this!!!!
                        officeId  : values.officeId
                    })

                    request.done( async () => {
                        gd.session.setAttendanceStatus = undefined
                        await gd.session.attendanceStatus()
                        await app.init()
                        gd.bus.triggerEvent("attendance:update")
                        app.render();
                        gd.modal.hide();
                    });
                },
            }
        });
    }

    clockOut = (app: AppMyAttendance)=>{
        gd.modal.showV4({
            className: '',
            component: ModalClockOut,
            params: {
                onSubmit: (values: any)=>{

                    const request = ApiAttendance.createClockOut({
                        userId    : gd.viewFor.userId,
                        date      : moment().format("YYYY-MM-DD"),
                        type      : 2,
                        comment   : values.comment,
                        deviceInfo: null,              /// Need to get this!!!!
                        officeId  : values.location
                    })

                    request.done( async () => {
                        gd.session.setAttendanceStatus = undefined
                        await gd.session.attendanceStatus()
                        await app.init()
                        gd.bus.triggerEvent("attendance:update")
                        app.render();
                        gd.modal.hide();
                    });
                },
            }
        });
    }

    editClockInOut = (clockIn: AttendanceEvent, clockOut: AttendanceEvent | boolean )=>{
        gd.modal.showV4({
            className: '',
            component: ModalEditAttendance,
            params: {
                clockIn : clockIn,
                clockOut: clockOut
            }
        });
    }

    addAttendance = (app: AppMyAttendance)=>{
        gd.modal.showV4({
            className: '',
            component: ModalAddAttendance,
            params: {
                app: app,
                onSubmit: (clockIn: AttendanceEvent, clockOut: AttendanceEvent, form: FormModel)=>{

                    const request = ApiAttendance.addAttendance({
                        date: clockIn.date.format("YYYY-MM-DD"),
                        timestampIn: clockIn.timestamp,
                        timestampOut: clockOut.timestamp,
                        userId: clockIn.createdByUserId,
                        commentIn: clockIn.comment,
                        commentOut: clockOut.comment,
                        deviceInfo: null,
                        officeId: clockIn.officeId
                    })

                    request.done( async () => {
                        gd.session.setAttendanceStatus = undefined
                        await gd.session.attendanceStatus()
                        await app.init()
                        gd.bus.triggerEvent("attendance:update")
                        app.render();
                        gd.modal.hide();
                    });

                    request.fail(()=>{
                        form.reset()
                    })
                },
            }
        });
    }
}
